import React from 'react'
import { AppBar, Toolbar, Typography } from '@material-ui/core';

export const Navbar = () => {
    return (
        <React.Fragment>
            <AppBar   position="fixed">
                <Toolbar>
                    <Typography variant="h6" color="inherit">
                    สินเชื่อสวัสดิการ “สู้ภัยโควิด”
                    </Typography>
                </Toolbar>
            </AppBar>
            <Toolbar />
        </React.Fragment>
    )
}
